<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import FlowCardQC from '@/shared/components/FlowCardQC/FlowCardQC.vue'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import { useI18n } from 'vue-i18n'
  import { useTimeoutFn } from '@vueuse/core'

  const { t } = useI18n()

  const phase = ref(0)

  const KEYS = [t('travel.common.success.text_1'), t('travel.common.success.text_2')]

  const description = computed(() => KEYS[phase.value])

  onMounted(() => {
    useTimeoutFn(() => (phase.value = 1), 6000)
  })
</script>

<template>
  <FlowCardQC :with-button="false" class="flow-success-loader">
    <WrapperQC direction="column" gap="var(--spacing-8)">
      <div class="success-animation">
        <svg
          width="200"
          height="200"
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject x="23.4794" y="18.2177" width="98.0412" height="162.111"
            ><div
              xmlns="http://www.w3.org/1999/xhtml"
              style="
                backdrop-filter: blur(3.76px);
                clip-path: url(#bgblur_0_26760_39683_clip_path);
                height: 100%;
                width: 100%;
              "
            ></div
          ></foreignObject>
          <rect
            data-figma-bg-blur-radius="7.52059"
            x="31"
            y="25.7383"
            width="83"
            height="147.07"
            rx="14.205"
            fill="#6568F4"
          />
          <foreignObject x="32.3474" y="9.60907" width="145.006" height="180.782"
            ><div
              xmlns="http://www.w3.org/1999/xhtml"
              style="
                backdrop-filter: blur(3.7px);
                clip-path: url(#bgblur_1_26760_39683_clip_path);
                height: 100%;
                width: 100%;
              "
            ></div
          ></foreignObject>
          <g data-figma-bg-blur-radius="7.39093">
            <path
              d="M53.6982 17.7158H122.43L169.247 67.3701V169.04C169.247 176.355 163.317 182.284 156.002 182.284H53.6982C46.3836 182.284 40.4542 176.355 40.4541 169.04V30.96C40.4542 23.6453 46.3836 17.7159 53.6982 17.7158Z"
              fill="url(#paint0_linear_26760_39683)"
              fill-opacity="0.8"
            />
            <path
              d="M53.6982 17.7158H122.43L169.247 67.3701V169.04C169.247 176.355 163.317 182.284 156.002 182.284H53.6982C46.3836 182.284 40.4542 176.355 40.4541 169.04V30.96C40.4542 23.6453 46.3836 17.7159 53.6982 17.7158Z"
              fill="url(#paint1_linear_26760_39683)"
              fill-opacity="0.8"
            />
            <path
              d="M53.6982 17.7158H122.43L169.247 67.3701V169.04C169.247 176.355 163.317 182.284 156.002 182.284H53.6982C46.3836 182.284 40.4542 176.355 40.4541 169.04V30.96C40.4542 23.6453 46.3836 17.7159 53.6982 17.7158Z"
              stroke="url(#paint2_linear_26760_39683)"
              stroke-width="1.43103"
            />
          </g>
          <path
            d="M122.738 17L169.962 67.0862H131.897C128.691 67.0862 127.088 67.0862 125.864 66.4623C124.787 65.9135 123.911 65.0378 123.362 63.9608C122.738 62.7363 122.738 61.1334 122.738 57.9276V17Z"
            fill="#6568F4"
          />
          <rect
            class="doc-line doc-line--1"
            x="63"
            y="148"
            width="35"
            height="14"
            rx="7"
            fill="#DBDCFB"
          />
          <rect
            class="doc-line doc-line--2"
            x="63"
            y="148"
            width="75"
            height="14"
            rx="7"
            fill="#DBDCFB"
          />
          <defs>
            <clipPath id="bgblur_0_26760_39683_clip_path" transform="translate(-23.4794 -18.2177)">
              <rect x="31" y="25.7383" width="83" height="147.07" rx="14.205" />
            </clipPath>
            <clipPath id="bgblur_1_26760_39683_clip_path" transform="translate(-32.3474 -9.60907)">
              <path
                d="M53.6982 17.7158H122.43L169.247 67.3701V169.04C169.247 176.355 163.317 182.284 156.002 182.284H53.6982C46.3836 182.284 40.4542 176.355 40.4541 169.04V30.96C40.4542 23.6453 46.3836 17.7159 53.6982 17.7158Z"
              />
            </clipPath>
            <linearGradient
              id="paint0_linear_26760_39683"
              x1="123.355"
              y1="224.5"
              x2="-78.5456"
              y2="9.69543"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#C8C9FC" />
              <stop offset="1" stop-color="#6568F4" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_26760_39683"
              x1="121.557"
              y1="224.5"
              x2="-80.568"
              y2="14.0815"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#C8C9FC" />
              <stop offset="1" stop-color="#6568F4" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_26760_39683"
              x1="-443.951"
              y1="445.595"
              x2="-248.827"
              y2="-182.06"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#6568F4" />
              <stop offset="1" stop-color="#C5CEFF" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <p class="paragraph-medium text-center">
        {{ description }}
      </p>
    </WrapperQC>
  </FlowCardQC>
</template>

<style lang="scss" scoped>
  .flow-success-loader {
    padding: var(--spacing-9);
  }

  .success-animation {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .doc-line {
    opacity: 0;
    animation: line-slide 2.2s ease-in-out infinite;
  }

  .doc-line--2 {
    animation-delay: 1.1s;
  }

  @keyframes line-slide {
    0% {
      opacity: 0;
      transform: translateY(0);
      width: 15px;
    }
    15% {
      opacity: 1;
      transform: translateY(0);
      width: 35px;
    }
    50% {
      opacity: 1;
      transform: translateY(-24px);
      width: 75px;
    }
    100% {
      opacity: 0;
      transform: translateY(-48px);
      width: 75px;
    }
  }
</style>
